module.exports = __webpack_public_path__ + "static/media/contact_hover.24301ab5.png";